import React from 'react';
import './Sidebarbutton.scss';
import '../../../style/typography.scss';
import {Tooltip} from '@mui/material';

const SideBarButton = ({name, onClick, index, icon, selected, onlyIcon}) => {
    const buttonContent = (
        <div
            className={`v2-sidebar-button ${selected && 'v2-sidebar-button-selected'}`}
            key={index}
            onClick={onClick}>
            {icon}
            {!onlyIcon &&
                <div className={'v2-side-bar-button-text-container'}>
                    <p className={`${selected ? 'v2-c-primary-500 body-1' : 'v2-c-text-title body-2'}`}>{name}</p>
                </div>}
        </div>
    );

    return onlyIcon ? (
        <Tooltip title={name}>
            {buttonContent}
        </Tooltip>
    ) : (
        buttonContent
    );
};

export default SideBarButton;
